/** localStorage key for the persisted react-query cache (see root.tsx QueryProvider). */
export const QUERY_CACHE_KEY = 'kc-tasks-cache';
